/**
 * @param urlField {HTMLInputElement}
 * @return {void}
 */
module.exports = function initURLFieldValue(urlField) {
    urlField.value = location.href;
}